const state = {
    filters: {
        pos: {
            default: [],
            active: []
        },
        category: {
            default: ["commonFilter", "uniqueFilter"],
            active: []
        }
    },
    audioData: {},
    thesaurusHeadword: "",
    thesaurus: [],
    filteredThesaurus: [],
    sortedAZThesaurus: {},
    isThesaurusLoaded: false,
    isMobileFilterPanelOpened: false,
    study: [],
    isSorted: false,
    orderSelected: "relevance",
    copiedSynonym: {},
    isCopyToastVisible: false
};

export default state;



// WEBPACK FOOTER //
// ./src/store/ThesaurusFilter/state.js